// File di entry point per Vite
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Importa la configurazione globale di axios
import './utils/axiosConfig';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);